export default {
    scheme: 'unikitty',
    author: 'Josh W Lewis (@joshwlewis)',
    base00: '#2e2a31',
    base01: '#4b484e',
    base02: '#69666b',
    base03: '#878589',
    base04: '#a5a3a6',
    base05: '#c3c2c4',
    base06: '#e1e0e1',
    base07: '#ffffff',
    base08: '#d8137f',
    base09: '#d65407',
    base0A: '#dc8a0e',
    base0B: '#17ad98',
    base0C: '#149bda',
    base0D: '#7864fa',
    base0E: '#b33ce8',
    base0F: '#d41acd',
};
